export default __webpack_public_path__ + "locales/hy-AM/BackupCodesDialog.json?hash=989722156b16963c376918a1c8cdfe79";